import { doc, getFirestore, collection } from 'firebase/firestore/lite';

export const getCollectionRef = (collectionName: string) =>
  collection(getFirestore(), collectionName);

export const getDocRef = (collectionName: string, id: string) =>
  doc(getFirestore(), collectionName, id);
